import { isEqual } from "./objects";

export function insertIf(conditional, ...elements) {
  return conditional ? elements : [];
}

export function contains(array, element) {
  return array.find(e => isEqual(e, element));
}
